import {del, get, post, put} from '../HTTP';
import {base64ToFile, getBase64, uploadDocsToS3, getBase64BIT} from '../utils/generalUtils';
import {SaveOrgImageBase64, showAlert} from '../actions/miscellaneousActions';
import {OrgModel} from '../model/OrgModel';
import {IHistory} from '../interfaces';
import {NO_PIC_IMAGE} from '../constants/generals';
import { IMAGEALLOWEDEXE } from '../constants/generals';

const uuidv1 = require('uuid/v1');

function mapOrgData(params, orgImageUrl, fileName) {
    const data = {
        'OrganizationName': params.OrganizationName,
        'Link': orgImageUrl ? orgImageUrl.replace(/ /g, '') : null,
        'Filename': fileName ? fileName.toString().replace(/ /g, '') : null,
        'FilePath': orgImageUrl ? '/logo' : null,
        'Category': params.Category,
        'SubCategory': params.SubCategory,
        'IsActive': true
    };

    if (params.OrganizationId) {
        data['OrganizationId'] = params.OrganizationId;
    }

    return data;
}

export async function getAllOrg() {
    try {
        OrgModel.deleteAllInstances();
        const response = await get('/GetOrganization', {});
        (response.data || []).forEach(instance => {
            instance.id = instance.OrganizationId;
            new OrgModel(instance).$save();
        });
    } catch (error) {
        showAlert({
                title: 'Oops..!!',
                text: error,
                type: 'error',
                closeOnConfirm: true
            },
            'submission');
        throw new Error(error);
    }
}

export async function getOrgDetails(orgId) {
    try {
        const response = await get(`GetOrganization?OrganizationId=${orgId}`, {});
        if (!response.data) {
            return;
        }
        let orgImageBase64 = NO_PIC_IMAGE;
        let OrgPicFile = null;
        const orgData = response.data[0];
        orgData.id = orgData.OrganizationId;
        if (orgData.Link && orgData.Link !== 'None') {
            orgImageBase64 = await getBase64(orgData.Link + '?expires=' + new Date().getMilliseconds());
            OrgPicFile = await base64ToFile(`data:image/png;base64,${orgImageBase64}`, orgData.Filename);
            SaveOrgImageBase64(`data:image/png;base64,${orgImageBase64}`);
            orgData.OrgPicFile = OrgPicFile;
            orgData.OrgImage = `data:image/png;base64,${orgImageBase64}`;
        }
        new OrgModel(orgData).$save();
    } catch (e) {
        showAlert({
                title: 'Oops..!!',
                text: e,
                type: 'error',
                closeOnConfirm: true
            },
            'submission');
        throw new Error(e);
    }
}

export async function createOrgInfo(params, orgPic, history: IHistory) {
    try {
        let orgPicData = {location: ''};
        let fileName = null;
        let base64BITImg = null;
        if (orgPic) {
            const extension = orgPic.type.split('/')[1];
            const orgLogoFile = new Blob([orgPic], {type: 'image/png'});
            const OrgPicFile = new FormData();
            // const Ext = this.props.Extensions;
            const Ext =  IMAGEALLOWEDEXE;
            base64BITImg = await getBase64BIT(orgPic);
            // alert('else' + base64BITImg);
            OrgPicFile.append('ProfilePic', orgLogoFile, `${uuidv1()}.${extension}`);
            fileName = `${uuidv1()}.${extension}`;
        }
        const data = mapOrgData(params, base64BITImg, fileName);
        data.FilePath = '/logo';
        data.Link = base64BITImg;
        const response = await post('/AddOrganization', data);
        showAlert({
            title: 'Thanks.!!',
            text: `Organization ${params.OrganizationName} is created..!!`,
            type: 'success',
            closeOnConfirm: true,
            confirmCallback: () => {
                history.push('/org/list');
            }
        }, 'submission', 5000);
    } catch (e) {
        showAlert({
                title: 'Oops..!!',
                text: e,
                type: 'error',
                closeOnConfirm: true
            },
            'submission');
        throw e;
    }

}

export async function updateOrgInfo(params, orgPic, history: IHistory) {
    try {
        let orgPicData = {location: ''};
        let fileName = null;
        let base64BITImg = null;
        if (orgPic) {
            const extension = orgPic.type.split('/')[1];
            const orgLogoFile = new Blob([orgPic], {type: 'image/png'});
            const OrgPicFile = new FormData();
            // const Ext = this.props.Extensions;
            const Ext =  IMAGEALLOWEDEXE;
            // fileName = `${params.OrganizationName}.${extension}`;
            // OrgPicFile.append('orgPic', orgLogoFile, fileName.replace(/ /g, ''));
            // orgPicData = await uploadDocsToS3(OrgPicFile.get('orgPic'), 'logo');
            // alert(Ext.indexOf('image/' + extension.toLowerCase()));
            // if (Ext !== undefined) {alert('if');
            //     if (Ext.indexOf('image/' + extension.toLowerCase()) === -1) {
            //         showAlert({
            //             title: 'Oops..!!',
            //             text: `Only ${Ext.join(', ')} files allowed.`,
            //             type: 'error',
            //             closeOnConfirm: true
            //         },
            //         'submission'); 
            //          return;
            //     }
            // } else {alert('else');
                base64BITImg = await getBase64BIT(orgPic);
                // alert('else' + base64BITImg);
                OrgPicFile.append('ProfilePic', orgLogoFile, `${uuidv1()}.${extension}`);
                fileName = `${uuidv1()}.${extension}`;
            // }
        }
        // const orgImageBase64 = await getBase64(orgPicData.location);
        // const data = mapOrgData(params, orgPicData.location, fileName);
        const data = mapOrgData(params, base64BITImg, fileName);
        data.FilePath = '/logo';
        data.Link = base64BITImg;

        const response = await put(`UpdateOrganization`, data);
        if (params.OrganizationName === 'SPI') {
            SaveOrgImageBase64(base64BITImg);
        }
        // SaveOrgImageBase64(`data:image/png;base64,${base64BITImg}`);
        showAlert({
            title: 'Thanks.!!',
            text: `Organization ${params.OrganizationName}'s information is updated..!!`,
            type: 'success',
            closeOnConfirm: true,
            confirmCallback: () => {
                history.push('/org/list');
            }
        }, 'submission', 5000);
    } catch (error) {
        showAlert({
                title: 'Oops..!!',
                text: error,
                type: 'error',
                closeOnConfirm: true
            },
            'submission');
        throw error;
    }
}

export async function deactivateOrganization(params: OrgModel, status: boolean, history: IHistory) {
    try {
        const data = params.props;
        data.IsActive = status;
        const response = await put(`UpdateOrganization`, data);
        OrgModel.deleteAllInstances();
        showAlert({
            title: 'Success...!!',
            text: `${data.OrganizationName}'s account is ${status ? 'Activated' : 'Deactivated'}.`,
            type: 'success',
            closeOnConfirm: true,
            confirmCallback: () => {
                history.push('/org/list');
            }
        }, 'submission', 5000);
        await getAllOrg();
    } catch (error) {
        showAlert({
                title: 'Oops..!!',
                text: error,
                type: 'error',
                closeOnConfirm: true
            },
            'submission');
        throw new Error(error);
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/services/organizationService.ts